import http from "../http";

import TokenService from "./token.service";

const AuthService = {
    hasPermission: (permission) => {
        const user = JSON.parse(localStorage.getItem("user"));
        // console.log(user, user.permissions);
        return user.permissions && user.permissions.includes(permission)
    },
    login: async (email, password) => {

        const response = await http.instance.post("/auth/login", {email: email, password: password});
        TokenService.setToken(response.data.accessToken, response.data.refreshToken);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        localStorage.setItem("permissions" ,JSON.stringify(response.data.user.permissions))
        localStorage.setItem("roles" ,JSON.stringify(response.data.user.roles))

        window.$cookies.set('cookie_test',response.data.accessTokenExpiration)
        http.setHeader();
        http.mountAuthInterceptor();
        return response.data.user;
    },
    refreshToken: async () => {
        const response = await http.instance.post("/auth/refresh", {RefreshToken: TokenService.getRefreshToken()});
        TokenService.setToken(response.data.accessToken, response.data.refreshToken);
        localStorage.setItem("user", JSON.stringify(response.data.user));

        http.setHeader();
        return response.data.user;
    },
    logoutService: () => {
        TokenService.removeToken();
        localStorage.removeItem("user");
        localStorage.removeItem("refresh_token");

        http.clearHeader();
        http.unmountAuthInterceptor();
    }
};

export default AuthService
